import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "column" }
const _hoisted_2 = { class: "column" }
const _hoisted_3 = { class: "column" }

import CheckboxButton from "@/components/checkbox_button.vue"
  import DateInput from "@/components/inputs/date.vue"
  import TextInput from "@/components/inputs/text.vue"
  import NumberInput from "@/components/inputs/number.vue"
  import {onBeforeMount, PropType, ref} from "vue"
  import {Order} from "@/endpoints/rutsolve/gql/generated/graphql"
  import EnumerationPicker from "@/components/selectors/enumeration.vue"
  import {Enumeration as EnumerationClient} from "@/endpoints/rutsolve/gql/resolvers/enumeration"
  import ErrorModal from "@/components/modals/error.vue"

  
export default /*@__PURE__*/_defineComponent({
  __name: 'purchase_order',
  props: /*@__PURE__*/_mergeModels({
    readOnly: {
      default: false,
      required: false,
      type: Boolean
    }
  }, {
    "value": {
    default: null,
    required: true,
    type: Object as PropType<Order>
  },
    "valueModifiers": {},
  }),
  emits: ["update:value"],
  setup(__props) {

  

  onBeforeMount(() => {
    read()
  })

  const error = ref<Error>(null)
  const enumerationClient = new EnumerationClient()
  const orderStatuses = ref<string[]>(null)
  const orderTypes = ref<string[]>([
      "PURCHASE_CREDIT",
      "PURCHASE_DEBIT",
      "PURCHASE_OFFER"
  ])
  const value = _useModel(__props, "value")

  async function read() {
    try {
      const response = await enumerationClient.readOrderEnumerations()
      orderStatuses.value = response.statuses
    } catch(e) {
      error.value = e
    }
  }

return (_ctx: any,_cache: any) => {
  const _component_scoped = _resolveComponent("scoped")!

  return (value.value)
    ? (_openBlock(), _createBlock(_component_scoped, { key: 0 }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            (orderTypes.value)
              ? (_openBlock(), _createBlock(EnumerationPicker, {
                  key: 0,
                  selection: value.value.type,
                  "onUpdate:selection": _cache[0] || (_cache[0] = ($event: any) => ((value.value.type) = $event)),
                  options: orderTypes.value,
                  readOnly: __props.readOnly,
                  title: "Type"
                }, null, 8, ["selection", "options", "readOnly"]))
              : _createCommentVNode("", true),
            (orderStatuses.value)
              ? (_openBlock(), _createBlock(EnumerationPicker, {
                  key: 1,
                  selection: value.value.status,
                  "onUpdate:selection": _cache[1] || (_cache[1] = ($event: any) => ((value.value.status) = $event)),
                  options: orderStatuses.value,
                  readOnly: __props.readOnly,
                  title: "Status"
                }, null, 8, ["selection", "options", "readOnly"]))
              : _createCommentVNode("", true),
            _createVNode(TextInput, {
              value: value.value.reference,
              "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((value.value.reference) = $event)),
              title: "Reference",
              readOnly: __props.readOnly
            }, null, 8, ["value", "readOnly"]),
            _createVNode(TextInput, {
              value: value.value.memorandum,
              "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((value.value.memorandum) = $event)),
              title: "Memorandum",
              readOnly: __props.readOnly,
              multiline: ""
            }, null, 8, ["value", "readOnly"])
          ]),
          _createElementVNode("div", _hoisted_2, [
            _createVNode(DateInput, {
              value: value.value.billedAt,
              "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((value.value.billedAt) = $event)),
              title: "Billed At",
              readOnly: __props.readOnly
            }, null, 8, ["value", "readOnly"])
          ]),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(TextInput, {
              value: value.value.currency,
              "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((value.value.currency) = $event)),
              title: "Currency",
              readOnly: __props.readOnly
            }, null, 8, ["value", "readOnly"]),
            _createVNode(CheckboxButton, {
              value: value.value.shiftedVAT,
              "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((value.value.shiftedVAT) = $event)),
              title: "Shift VAT",
              readOnly: __props.readOnly
            }, null, 8, ["value", "readOnly"]),
            _createVNode(EnumerationPicker, {
              selection: value.value.discountType,
              "onUpdate:selection": _cache[7] || (_cache[7] = ($event: any) => ((value.value.discountType) = $event)),
              options: ['FIXED', 'RATE', 'SUBTRACTION'],
              readOnly: __props.readOnly,
              title: "Discount Type"
            }, null, 8, ["selection", "readOnly"]),
            _createVNode(NumberInput, {
              value: value.value.discountValue,
              "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((value.value.discountValue) = $event)),
              title: "Discount Value",
              readOnly: __props.readOnly
            }, null, 8, ["value", "readOnly"])
          ]),
          (error.value)
            ? (_openBlock(), _createBlock(ErrorModal, {
                key: 0,
                error: error.value,
                "onUpdate:error": _cache[9] || (_cache[9] = ($event: any) => ((error).value = $event))
              }, null, 8, ["error"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}
}

})